module.exports = __webpack_public_path__ + "static/media/bg.07f7f250.mp4";